// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1hHyM","icon":"SortAdornment_icon__1RaaY","up":"SortAdornment_up__3Pnsi","down":"SortAdornment_down__1ldqT","active":"SortAdornment_active__3CmJ-"};